import Close from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC, ReactElement, Ref, useCallback } from 'react';

import { COLOR } from '../../../theme/type';
import { colorToCss } from '../../../theme/utils';
import { H2 } from '../../heading/Hx';
import Section from '../../section/Section';
import {
  CloseDialogButton,
  OuterBox,
  ScrollableContentBox,
  StaticImage,
  StaticImageBox,
} from './styled';

type ImageDialogProps = {
  content: ReactElement;
  image: string;
  onClose?: () => void;
  ref?: Ref<HTMLDivElement>;
  title: string;
};

const ImageDialog: FC<ImageDialogProps> = ({ content, image, onClose, ref, title }) => {
  const theme = useTheme();
  const isSM = useMediaQuery(theme.breakpoints.up('sm'));
  const isMD = useMediaQuery(theme.breakpoints.up('md'));
  const screenKey = isMD ? 'md' : isSM ? 'sm' : 'xs';

  const mobile = image.replace('.jpg', '-mobile.jpg');
  const img = { md: image, sm: mobile, xs: mobile };
  const imgH = { md: '50vh', sm: '57vh', xs: '45vh' };
  const buttonR = { md: '24px', sm: '24px', xs: '8px' };

  const handleClose = useCallback(() => onClose?.(), [onClose]);

  return (
    <Dialog fullWidth id='image-dialog' maxWidth='xl' onClose={handleClose} open={true} ref={ref}>
      <OuterBox sx={{ backgroundColor: colorToCss(COLOR.Dark3) }}>
        <CloseDialogButton
          aria-controls='image-dialog'
          aria-label='close dialog'
          onClick={handleClose}
          sx={{ right: buttonR[screenKey] }}
        >
          <Close sx={{ height: '30px', width: '30px' }} />
        </CloseDialogButton>

        <StaticImageBox sx={{ height: imgH[screenKey] }}>
          <StaticImage alt={title} src={img[screenKey]} />
        </StaticImageBox>

        <ScrollableContentBox sx={{ paddingTop: imgH[screenKey] }}>
          <Section background={COLOR.Dark3}>
            <H2>{title}</H2>
            {content}
          </Section>
        </ScrollableContentBox>
      </OuterBox>
    </Dialog>
  );
};

export default ImageDialog;
